import { render, staticRenderFns } from "./TotalInfo.vue?vue&type=template&id=7ed767b1&scoped=true&"
import script from "./TotalInfo.vue?vue&type=script&lang=js&"
export * from "./TotalInfo.vue?vue&type=script&lang=js&"
import style0 from "./TotalInfo.vue?vue&type=style&index=0&id=7ed767b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed767b1",
  null
  
)

export default component.exports